import * as Sentry from '@sentry/react';
import { Button, Col, Modal, Row } from "antd";
import SpinLoader from "components/Loader/SpinLoader";
import { useAlert } from "components/UI/alertSakeBar/alertProvider";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import { usePlacementExamSession } from "store/placement_exam/selectors";
import { handleClearPlacementSession, handleLogPlacementBug, handlePlacementExamAiGrading, handleUpdatePlacementExamSubmissions } from "store/placement_exam/thunks";
import styled from "styled-components";
import { exitFullScreen } from "utils";
import {
  placement_exam_logo,
  PlacementExamStopIcon,
  PlacementSectionNumberBg 
} from "utils/assets/images";
import { FullScreenModal } from "./SectionVideoPlayer";
import SentryWrap from 'components/Sentry';
const NumberContainer = styled.div`
  height: 40px;
  width: 40px;
  font-size: 24px;
  border-radius: 50%;
  background-image: url(${PlacementSectionNumberBg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffff00eb;
  text-shadow: -1px -2px 0px #1b1a1a,  
              1px -1px 0px #1b1a1a,  
             -1px  1px 0px #1b1a1a,  
              1px  1px 0px #1b1a1a;
  font-style: italic;
  font-weight: bold;

  @media screen and (max-width: 420px) {
        height: 30px;
        width: 30px;
        font-size: 20px;
    }
`;
const SectionArea = styled.div`
  cursor: pointer;
`;
const FinalSectionModal = ({ onCancle, onOk, show }) => {
  return (
    <Modal
      className="studentQuestionModal"
      open={show}
      onCancel={onCancle}
      footer={null}
    >
      <div className="stdntModalTxt">
        <img src={PlacementExamStopIcon} />
        <p>
          ¿Seguro que estás listo <br /> para entregar tu trabajo?
        </p>
      </div>
      <div style={{ textAlign: "right" }}>
        <button onClick={onOk} className="next-button">
          Entregar
        </button>
      </div>
    </Modal>
  );
};
const FinalSubmissionErrorModal = ({ visible, onRetry, onCancel }) => (
  <Modal
    open={visible}
    onCancel={onCancel}
    footer={null}
    className="studentQuestionModal"
  >
    <div className="stdntModalTxt" style={{ flexDirection:"column"}}>
      <p>Ha ocurrido un error durante el envío.</p>
      <p>Por favor, vuelve a intentarlo.</p>
    </div>
    <div style={{ textAlign: "right" }}>
      <Button onClick={onRetry} className="next-button">Reintentar</Button>
    </div>
  </Modal>
);
const IntenetLostAlertIssue = ({ visible, onOk, onCancel }) => (
  <Modal
    open={visible}
    onCancel={onCancel}
    footer={null}
    className="studentQuestionModal"
  >
    <div className="stdntModalTxt" style={{ flexDirection: "column" }}>
      <p>Parece que tienes problemas de conexión a internet. Por favor, verifica tu conexión e intenta nuevamente.</p>
    </div>
    <div style={{ textAlign: "right" }}>
      <Button onClick={onOk} className="next-button">Bueno</Button>
    </div>
  </Modal>
);
const useTimer = (durationInMinutes, onFinishCallback) => {
  const [timeLeft, setTimeLeft] = useState(() => {
    // Retrieve remaining time from sessionStorage if it exists
    if(!durationInMinutes) return 0;
    const storedTime = sessionStorage.getItem("remainingTime");
    return storedTime ? parseInt(storedTime, 10) : durationInMinutes * 60; // Convert minutes to seconds
  });
  const timerRef = useRef(null);
  
  useEffect(() => {
    if (timeLeft > 0) {
      timerRef.current = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timerRef.current);
            onFinishCallback();
            return 0;
          }
          const newTime = prev - 1;
          sessionStorage.setItem("remainingTime", newTime); // Store remaining time in sessionStorage
          return newTime;
        });
      }, 1000);
    }

    return () => {
      if (timerRef.current) clearInterval(timerRef.current); // Cleanup timer on unmount
    };
  }, [timeLeft, onFinishCallback]);

  return moment.utc(timeLeft * 1000).format("mm:ss");
};

const PlacementExamSubmission = () => {
    const showAlert = useAlert();
  const location = useLocation();
  							  const navigate = useNavigate();
  const sessionInfo = usePlacementExamSession();
  const [sections, setSection] = useState([]);
  const [sessionData, setSessionData] = useState({});
  const [final_submission_modal, setFinalSubmissionModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const disptch = useDispatch();
const [openFullScreen, setOpenFullScreen] = useState();
const [errorModalVisible, setErrorModalVisible] = useState(false);
const [noInternateModal, setNoInternateModal] = useState(false);
const [resubmitAttempted, setResubmitAttempted] = useState(false);

  useEffect(() => {
    const fullscreenRefreshCount = parseInt(sessionStorage.getItem("fullscreen_refresh_count") || "0", 10);
    if (fullscreenRefreshCount >= 2 && !document.fullscreenElement) {
      showAlert("You have exited fullscreen multiple times. Submitting exam automatically.", "error");
      sessionStorage.removeItem("fullscreen_refresh_count");
      setTimeout(() => {
        handleFInalSubmission();
      }, 1000);
      return;
    }
    if (fullscreenRefreshCount > 0 && fullscreenRefreshCount < 2 && !document.fullscreenElement) {
      showAlert(`Please stay in fullscreen mode. This is warning ${fullscreenRefreshCount}/2`, "warning");
      setOpenFullScreen(true);
    }

    async function handleVisibilityChange() {
      if (document.hidden) {
        const switchTabCount = sessionStorage.getItem("switch_tab_count") || "0";
        if (switchTabCount === "1") {
          handleFInalSubmission();
          sessionStorage.removeItem("switch_tab_count");
          return;
        }
        alert("Please do not switch tabs or navigate away, as it will be automatically submitted next time.");
        sessionStorage.setItem("switch_tab_count", "1");
      }
    }

    function handleBeforeUnload(event) {
      event.preventDefault();
      event.returnValue = "Please do not refresh the page, as it will be automatically submitted next time.";

      const switchTabCount = sessionStorage.getItem("switch_tab_count") || "0";
      if (switchTabCount === "1") {
        handleFInalSubmission();
        sessionStorage.removeItem("switch_tab_count");
      } else {
        sessionStorage.setItem("switch_tab_count", "1");
      }

      // Track fullscreen refresh attempts
      if (!document.fullscreenElement) {
        const fullscreenRefreshCount = parseInt(sessionStorage.getItem("fullscreen_refresh_count") || "0", 10);
        sessionStorage.setItem("fullscreen_refresh_count", (fullscreenRefreshCount + 1).toString());
      }
    }

    function handleFullScreenChange() {
      if (!document.fullscreenElement) {
        setOpenFullScreen(true);
        // setTimeout(() => {
        //   goFullScreen();
        // }, 500)
      }
    }
    document.addEventListener("visibilitychange", handleVisibilityChange);
    document.addEventListener("fullscreenchange", handleFullScreenChange);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      document.removeEventListener("fullscreenchange", handleFullScreenChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (sessionInfo && sessionInfo.session_info) {
      try {
        const { session_info, exam_info } = sessionInfo;
        const { assignment } = exam_info;
        const { questions } = assignment;
        setSessionData(session_info);
        setSection(questions);
      } catch (error) {
        Sentry.captureException(`492 Error in setSessionData: ${error}`);
        console.log(error.message, "error i getting info");
      }
    }
  }, [sessionInfo]);
  useEffect(()=>{
    if(!sessionInfo||!sessionInfo.session_info||!sessionInfo.session_info.id){
      navigate("/placement-exam");
    }
  },[sessionInfo])


  const onSubmissionFinish = () => {
    setFinalSubmissionModal(true);
  };
  const closeFinalSectionModal = () => {
    setFinalSubmissionModal(false);
  };
  const moveFinalScreen = () => {
    navigate("/placement-exam/final-submission");
    sessionStorage.removeItem("remainingTime");
    sessionStorage.removeItem("fullscreen_refresh_count");
  };
  const onClickSections = (currentSectionIndex) => {
    navigate(
      `/placement-exam/exam?session_id=${sessionData?.id || 0
      }&section=${currentSectionIndex}&question=0`
    );
  };
  const reportFailedSubmission = async (error) => {
    try {
      const reportPayload = {
        sessionInfo,
        timestamp: new Date().toISOString(),
        reason: "Double submission failure",
        user_agent: navigator.userAgent,
        error_messgae: error?.message
      };
      await handleLogPlacementBug(reportPayload)
      showAlert("Se ha registrado el problema para su revisión.", "info");
      setTimeout(() => {
        disptch(handleClearPlacementSession())
        moveFinalScreen()
        exitFullScreen()
      }, 1000)
    } catch (error) {
      Sentry.captureException(`493 Error in reportFailedSubmission: ${error}`);
      console.error("Report failed:", error);
      showAlert("Error al registrar el problema.", "error");
    }
  };
  const handleFInalSubmission = async () => {
    closeFinalSectionModal();
    setLoader(true);
    try {
      if (sessionInfo.submission?.id) {
        showAlert("updating...")
        const dt = await disptch(handleUpdatePlacementExamSubmissions({
          answers: sessionInfo.answers || [],
          completed: true,
          id: sessionInfo.submission?.id
        }))
        if (dt && dt.success) {
          await handlePlacementExamAiGrading(sessionInfo.submission?.id)
          setTimeout(()=> {
            disptch(handleClearPlacementSession())
          },1000)
          moveFinalScreen()
          exitFullScreen()
        } else {
          throw new Error(dt?.message || "SUB-01 something went wrong");
        }
      } else {
        throw new Error("SUB-02 submission not found");
      }
    } catch (error) {
      Sentry.captureException(`494 Error in handleFInalSubmission: ${error}`);
      console.error("Submission Error:", error);
      const isOffline = !navigator.onLine;
      const isNetworkError = error.message?.includes("Failed to fetch") || error.message?.includes("NetworkError");
      if (isOffline || isNetworkError) {
        setNoInternateModal(true);
      } else {
        showAlert("SUB-03 something went wrong", "error");
        if (resubmitAttempted) {
          await reportFailedSubmission(error);
        } else {
          setResubmitAttempted(true);
          setErrorModalVisible(true);
        }
      }
    } finally {
      setLoader(false)
    }

  };
  const formattedTime = useTimer(sessionInfo?.exam_info?.assignment?.duration, handleFInalSubmission);
    const dist_config  = sessionInfo.exam_info?.config || {}
  return (
    <SentryWrap>
    <div>
         <FullScreenModal show={openFullScreen} onOk={()=>setOpenFullScreen(false)}/>
      <FinalSubmissionErrorModal
        visible={errorModalVisible}
        onRetry={() => {
          setErrorModalVisible(false);
          handleFInalSubmission();
        }}
        onCancel={() => setErrorModalVisible(false)}
      />
      <IntenetLostAlertIssue
        visible={noInternateModal}
        onOk={() => {
          setNoInternateModal(false);
        }}
        onCancel={() => setNoInternateModal(false)}
      />
      <FinalSectionModal
        show={final_submission_modal}
        onCancle={closeFinalSectionModal}
        onOk={handleFInalSubmission}
      />
      <SpinLoader dataloader={loader} />
      <header className="studentFormHeader studntQuestionHedr">
        <Row align="middle">
          <Col xs={4} sm={4} md={4} className="logo-col">
            <div className="StudentSecondLogoPart mnageEductionLogo">
              <img src={placement_exam_logo} />
            </div>
          </Col>
          <Col xs={16} sm={16} md={16} className="logo-col">
            <div className="studentFormLogo mngeCoronaLogo">
               {dist_config?.logo ?  <img src={dist_config?.logo} alt="Placement District Logo" />:null}
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} className="hedrTimer">
            {formattedTime && sessionInfo?.exam_info?.assignment?.duration ? <div className="stdntQstntimer">
              <span>{formattedTime}</span>
            </div> : null}
          </Col>
        </Row>
      </header>
      <div>
        <div className="section-list-container">
          <p>Revisa tu trabajo o si estás listo entrégalo.</p>
          <div className="submissionSections">
            {sections.map((section, index) => (
              <SectionArea
                key={section.id}
                className="placementSubmissionsection"
                onClick={() => onClickSections(index)}
              >
                <span className="placementSubmissionText">Section</span>
                <div className="PlacementSectionNumberBgSec">
                  <NumberContainer>{index + 1}</NumberContainer>
                </div>
              </SectionArea>
            ))}
          </div>
        </div>
      <footer className="stdntSubmitQstnBtn submissionSubmitBtn">
        <button className="next-button" onClick={onSubmissionFinish}>
          Submit
        </button>
      </footer>
      </div>
    </div>
    </SentryWrap>
  );
};

export default PlacementExamSubmission;
